module.exports = __webpack_public_path__ + "static/img/bg_1.60bb8d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_1.png
// module id = 782
// module chunks = 1